import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IClassroomReq } from '../../../models/classrooms.model';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/campus/classroom/Editor';
import useAxios from '../../../hooks/useAxios';
import { createClassroom } from '../../../api/classrooms.api';
import ErrorResponse from '../../../components/ErrorResponse';
import useNotification from '../../../hooks/useNotification';

const CampusClassroomCreate: FC = () => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data, isLoading, error, execute } = useAxios();

  const onSubmit = async (campusCode: string, req: IClassroomReq) => {
    execute(createClassroom(campusCode, req));
  };

  useEffect(() => {
    if (!isLoading && data) {
      successNotification(t('common.message.create'));
    }
  }, [data, isLoading]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader parentMenu={t('common.menu.campus')} currentMenu={t('campus.classroom.title4')} />
      <Editor classroom={null} onSubmit={onSubmit} onDelete={null} />
      <Footer />
    </div>
  );
};

export default CampusClassroomCreate;
